import { Alert } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import React from 'react';
import { useIntl } from 'react-intl';
import { technicalMetadataWarningsAtom } from '../../atoms/approval';
import TechnicalMetadataWarning from './TechnicalMetadataWarning';

export function TechnicalMetadataWarnings() {
  const intl = useIntl();
  const technicalMetadataWarnings = useAtomValue(technicalMetadataWarningsAtom);

  return technicalMetadataWarnings?.length > 0 ? (
    <Alert
      type="error"
      title={intl.formatMessage({
        defaultMessage: 'There are issues with this videos metadata',
        id: 'd669d',
      })}
    >
      {technicalMetadataWarnings.map((warning) => (
        <TechnicalMetadataWarning
          key={`metadata-warnings-${warning.code}`}
          warning={warning}
        />
      ))}
    </Alert>
  ) : null;
}

export default { TechnicalMetadataWarnings };
